import { render, staticRenderFns } from "./penengah.vue?vue&type=template&id=70c0d75d&scoped=true"
import script from "./penengah.vue?vue&type=script&lang=js"
export * from "./penengah.vue?vue&type=script&lang=js"
import style0 from "./penengah.vue?vue&type=style&index=0&id=70c0d75d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c0d75d",
  null
  
)

export default component.exports